import { createSlice } from "@reduxjs/toolkit";
import { LocalStorageKeys } from "../core";

const initialState = {
  isLoggedIn: localStorage.getItem(LocalStorageKeys.gymToken) ? true : false,
  gym: null,
  token: localStorage.getItem(LocalStorageKeys.gymToken),
  isLoading: false,
};

const gymReducerSlice = createSlice({
  name: "gyms",
  initialState,
  reducers: {
    changeLoadingState: (state, action) => {
      state.isLoading = action.payload;
    },
    setGym: (state, action) => {
      state.gym = action.payload;
      state.isLoading = false;
    },
    setGymLogin: (state, action) => {
      state.isLoggedIn = true;
      state.isLoading = false;
      localStorage.setItem(LocalStorageKeys.gymToken, action.payload);
    },
    setGymLogout: (state) => {
      localStorage.removeItem(LocalStorageKeys.gymToken);
      state = {
        isLoggedIn: false,
        gym: null,
        token: null,
      };
    },
    
  },
});

export const {
  setGym,
  setGymLogin,
  setGymLogout,
  changeLoadingState,
  setGymProfile,
} = gymReducerSlice.actions;

export default gymReducerSlice.reducer;
